import React, { useMemo } from 'react';
import { append, indexBy, prop, without } from 'ramda';
import { useUnmount } from 'react-use';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { DndProvider } from 'react-dnd'; // We can export a common set of wrappers from the UI Kit
import { SettingsRow } from './settings-row';
import { Divider } from '../../../divider';
import { useChangeColumnOrder, useColumnsList } from './hooks';
import { ListTitle, StyledSettingsRowWrapper } from './styled';
const compareByColumnName = (columnsMap) => (a, b) => {
    var _a;
    return (_a = columnsMap[a]) === null || _a === void 0 ? void 0 : _a.columnName.localeCompare(columnsMap[b].columnName);
};
// TODO: https://gitlab.apptrium.io/invent/frontend/wl-ui-kit/-/merge_requests/322
export const ColumnSettingsDndList = ({ columns, hiddenColumns, columnOrder, limit, setColumnOrder, setHiddenColumns, needUnselectedDown = true, listTitle, tooltipStyle }) => {
    const { orderedColumnIds, filteredColumnIds } = useColumnsList(columns, columnOrder);
    const columnsMap = useMemo(() => indexBy(prop('id'), columns), [columns]);
    useUnmount(() => {
        if (needUnselectedDown) {
            const selectedIds = orderedColumnIds.filter((id) => !hiddenColumns.includes(id));
            const unselectedIds = [...hiddenColumns].sort(compareByColumnName(columnsMap));
            setColumnOrder([...selectedIds, ...unselectedIds]);
        }
    });
    const handleChange = (columnId) => (e) => {
        const isVisible = e.currentTarget.checked;
        const fn = isVisible ? without([columnId]) : append(columnId);
        setHiddenColumns(fn(hiddenColumns));
    };
    const changeColumnOrder = useChangeColumnOrder(orderedColumnIds, filteredColumnIds, setColumnOrder);
    const visibleCount = useMemo(() => columns.length - hiddenColumns.length, [columns, hiddenColumns]);
    const limitExceeded = useMemo(() => (limit ? limit <= visibleCount : false), [limit, visibleCount]);
    return (React.createElement(React.Fragment, null,
        listTitle && (React.createElement(React.Fragment, null,
            React.createElement(ListTitle, null, listTitle),
            React.createElement(Divider, null))),
        React.createElement(DndProvider, { backend: HTML5Backend },
            React.createElement(StyledSettingsRowWrapper, null, filteredColumnIds.map((id, index) => {
                var _a, _b, _c;
                return (React.createElement(SettingsRow, { key: id, id: id, label: ((_a = columnsMap[id]) === null || _a === void 0 ? void 0 : _a.shortTitle) || ((_b = columnsMap[id]) === null || _b === void 0 ? void 0 : _b.columnName), checked: !hiddenColumns.includes(id), onChange: handleChange(id), onOrderChange: changeColumnOrder, index: index, disabled: ((_c = columnsMap[id]) === null || _c === void 0 ? void 0 : _c.required) || (limitExceeded && hiddenColumns.includes(id)), tooltipStyle: tooltipStyle }));
            })))));
};
